import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { useMixpanel } from "react-mixpanel-browser";
import CurrencyFormatter from "../../../shared/currency-formatter";
import { variants } from "../../../shared/variants";
import { useTranslation } from "react-i18next";
import GiCancel from "../../../../assets/images/GiCancel.png";



function PaymentOpt({ setCurrentScreen }: any) {
  const { t } = useTranslation();
  const q: any = sessionStorage.getItem("quote")!
    ? sessionStorage.getItem("quote")!
    : sessionStorage.getItem("quote")!;

  const [showSucDialog, setShowSucDialog] = useState(false);

  const quote = JSON.parse(q);

  const mixpanel = useMixpanel()

  const showDialog = () => {
    let elem: any = document.getElementById("credit-rting-cont") || "";
    elem.style.filter = "blur(5px)";
    elem.style.background = "rgba(0, 0, 0, 0.05)";
    setShowSucDialog(true);
  };

  const hideDialog = (status: any) => {
    let elem: any = document.getElementById("credit-rting-cont") || "";

    elem.style.filter = "none";
    elem.style.background = "none";
    setShowSucDialog(false);
  };

  const handlePP = () => {
    hideDialog("suc");
    sessionStorage.setItem("payment-screen", "credit-form");
    sessionStorage.setItem("paymentOption", "pp");
    setCurrentScreen("credit-form");
  };

  const successDialog = (
    <div className="l-dialog-container l-dialog-container-more-information">
      <div>
        <div
          className="cancel d-flex justify-content-end mb-5"
          style={{ cursor: "pointer" }}
          onClick={hideDialog}
        >
          <img src={GiCancel} height="20" />
        </div>
        <p className="dialog-p-t mt-1">{t("paymentOpt.greatChoice")}</p>
        <p className="dialog-p mt-4 dialog-p-more-information">
          {t("paymentOpt.verifyEmploymentMsg")}
        </p>
        <div className="d-flex flex-column justify-conter-center align-items-center">
          <div onClick={() => handlePP()} className="mt-4 dialog-proc-btn">
            {t("paymentOpt.letsProceed")}
          </div>
        </div>
      </div>
    </div>
  );

  useEffect(()=> {
    if (mixpanel.config.token) {
      mixpanel.track("PageView", {
        pageName: "Travel|Payment-options",
      });
    }
  }, [mixpanel])

  return (
    <div>
      {showSucDialog && successDialog}
      <div id="credit-rting-cont">
        <motion.div
          variants={variants}
          initial="enter"
          animate="center"
          exit={{ opacity: 0 }}
        >
          <div className="container">
            <div className="ky-inputs-container">
              <div className="reg-title payment-title text-left">
                {t("paymentOpt.almostThere")} <br />
                <span className="span-title">
                  {t("paymentOpt.payQuestion")}
                </span>
              </div>
              <br />
              <div className="payment-options">
                <div
                  className="one-time"
                  onClick={() => {
                    sessionStorage.setItem("payment-screen", "payment-method");
                    sessionStorage.setItem("paymentOption", "direct");
                    setCurrentScreen("payment-method");
                  }}
                >
                  <span>{t("paymentOpt.oneTimePay")}</span>
                  <span className="option-amount">
                    <CurrencyFormatter
                      value={quote?.amount}
                      displayType={"text"}
                      suffix
                    />
                  </span>
                </div>
                {/* {quote.amount >= 10000 && (
                  <div
                    className="payment-plan"
                    onClick={() => {
                      showDialog();
                    }}
                  >
                    <span>{t("paymentOpt.installments")}</span>
                    <span className="option-amount">
                      {t("paymentOpt.installmentsSub")}
                    </span>
                  </div>
                )} */}
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
}

export default PaymentOpt;
